import React, {Component} from 'react';
import ChatBot from 'react-simple-chatbot';
import {ThemeProvider} from 'styled-components'
import robot from './robot.svg';

const theme = {
    background: '#f5f8fb',
    fontFamily: 'Poppins, sans-serif',
    headerBgColor: '#0877a8',
    headerFontColor: '#fff',
    headerFontSize: '15px',
    botBubbleColor: '#0877a8',
    botFontColor: '#fff',
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
    maxHeight: "20%"
}

function GoToPage(){
  // window.open('https://api.whatsapp.com/send/?phone=542612565651&text&type=phone_number&app_absent=0', "_blank");
  return <a style={{color:'white'}} href='https://api.whatsapp.com/send/?phone=542612565651&text&type=phone_number&app_absent=0' target="_blank">Ir a WhatsApp</a>
  }

function Prueba() {
  return (
    <ThemeProvider theme={theme}>
    <ChatBot
    floating={true}
    width="300px"
    headerTitle="Chat con Nosotros"
    floatingIcon={robot}
    height="400px"
    botDelay="300"
    steps={[
        {
          id:"1",
          message: 'Hola, Mi Nombre es Botcito, ¿Cuál es tu nombre?',
          trigger: "2",
        },
        {
        id: "2",
        user: true,
        trigger: "3",
        },
        {
          id: "3",
          message: 'Hola, un gusto de conocerte',
          trigger: "4",
        },
        {
          id: "4",
          message: '¿Necesitas ayuda con Algo?',
          trigger: "5",
        },
        {
          id: "5",
          options: [
              {value: "y", label: "Si", trigger: "6A"},
              {value: "n", label: "No", trigger: "6B"},
          ]
        },
        {
          id: "6A",
          message: 'Genial!, ¿Estás buscando un producto o un servicio?',
          trigger: "6",
        },
        {
          id: "6B",
          message: 'Vale, Me quedaré por aquí si necesitas mi ayuda',
          trigger: "algo",
        },
        {
          id: "algo",
          options: [
              {value: "y", label: "Presiona acá si necesitas algo ;)", trigger: "6A"},
          ]
        },
        {
          id: "6",
          options: [
              {value: 'y', label: "Producto", trigger: "producto"},
              {value: 'n', label: "Servicio", trigger: "servicio"},
          ]
        },
        {
          id: "producto",
          message: "¿Cómo te gustaría comunicarte con nuestro Agente Autorizado?",
          trigger: "mensajeria",
        },
        {
          id: "servicio",
          message: "¿Cómo te gustaría comunicarte con nuestro Agente Autorizado?",
          trigger: "mensajeria",
        },
        {
          id: "mensajeria",
          options: [
              {value: 'y', label: "Telegram", trigger: "telegram"},
              {value: 'n', label: "Whatsapp", trigger: "whatsapp"},
          ]
        },
        {
          id:"telegram",
          message: 'Contáctanos en @LaConsola',
          trigger: "7",
        },
        {
          id:"whatsapp",
          component: <GoToPage/>,
          asMessage: true,
          trigger: "7",
        },
        {
          id: "7",
          message: '¿Necesitas ayuda con Algo Más?',
          trigger: "5",
        },



    ]}
    />
    </ThemeProvider>
  )
}

export default Prueba